"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  x0: 0,
  x025: 1,
  x05: 2,
  x1: 4,
  x2: 8,
  x3: 12,
  x4: 16,
  x5: 20,
  x6: 24,
  x8: 32,
  x10: 40,
  x12: 48,
  x15: 60,
  x20: 80,
  sizeBase: 4,
  sizeGrid: 20,
  fontSize1: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize2: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize3: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize4: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize5: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize6: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize7: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontSize8: {
    fontSize: 44,
    lineHeight: "52px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  toneValueX1: 0.04,
  toneValueX2: 0.08,
  toneValueX3: 0.12,
  toneValueX4: 0.16,
  toneValueX6: 0.24,
  toneValueX8: 0.32,
  toneValueX12: 0.48,
  toneValueX18: 0.72,
  toneValueOverlay: 0.48,
  toneValueBase: 0.48,
  toneValueViewer: 0.88,
  toneValueToolbar: 0.24,
  toneValueHover: 0.04,
  toneValueActive: 0.08,
  toneValueFocus: 0.08,
  depth0: "none",
  depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
  depth2: "0 4px 32px 0 rgba(0, 0, 0, 0.32)",
  depth3: "0 16px 48px 0 rgba(0, 0, 0, 0.48)",
  depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
  colorBorder: {
    normal: "rgba(0,0,0,0.12)",
    hover: "rgba(0,0,0,0.24)",
    active: "rgba(0,0,0,0.48)",
    focus: "rgba(0,0,0,0.24)"
  },
  colorDivider: {
    normal: "rgba(0,0,0,0.08)"
  },
  typeBorderButton: "solid",
  typeBorderPosition: "inset",
  animationDurationL: "0.4s",
  animationDurationM: "0.2s",
  animationDurationS: "0.1s",
  transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
  paddingBase: 16,
  layoutWidthDesktopS: 768,
  colorPrimary: {
    normal: "#005ff9",
    hover: "#005BEF",
    active: "#0057E5"
  },
  colorSecondary: {
    normal: "#ff9e00",
    hover: "#F59800",
    active: "#EB9100"
  },
  sizeBorderWidth: 1,
  sizeBorderWidthTab: 2,
  sizeBorderWidthBar: 4,
  sizeBorderWidthAccent: 8,
  sizeBorderWidthAccentSecondary: 4,
  sizeBorderRadius: 2,
  sizeBorderRadiusPaper: 2,
  fontWeight: 400,
  fontWeightBold: 700,
  fontFamily: "Helvetica, Arial, sans-serif",
  fontSize: 17,
  lineHeight: 24,
  fontH0: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 20
  },
  fontH1: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 16
  },
  fontH2: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 12
  },
  fontH3: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 12
  },
  fontH4: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 12
  },
  fontH5: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 8
  },
  fontH6: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 8
  },
  fontBody: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontParagraph: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif",
    marginBottom: 24
  },
  fontList: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontListItem: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontFootnote: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontLead: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontQuote: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontTableHeader: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontControl: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontControlLabel: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontTab: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  fontBadge: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 700,
    fontFamily: "Helvetica, Arial, sans-serif",
    letterSpacing: "1px",
    textTransform: "uppercase"
  },
  fontDisclaimer: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "Helvetica, Arial, sans-serif"
  },
  sizeControlHeight: 48,
  sizeControlButtonWidthMin: 130,
  sizeControlButtonIconWidth: 48,
  sizeControlButtonSliderHeight: 24,
  sizeControlButtonSliderWidth: 12,
  sizeControlButtonSliderWidthPointer: 16,
  sizeControlButtonSmallHeight: 32,
  sizeControlButtonSmallWidth: 32,
  sizeControlFieldWidthMin: 328,
  sizeControlLabelWidth: 184,
  sizeControlCheckHeight: 16,
  sizeControlCheckWidth: 16,
  sizeProgress: 4,
  sizeProgressScroll: 12,
  sizeDotBullet: 4,
  sizeDotIndicate: 8,
  sizeDotClickable: 12,
  sizeArrowHeight: 8,
  sizeArrowWidth: 12,
  sizePopupSmall: 420,
  sizePopupMedium: 680,
  sizePopupLarge: 880,
  paddingControlHorizontal: 12,
  paddingControlVertical: 0,
  paddingControlMore: 8,
  paddingControlMoreIcon: 12,
  paddingControlButton: 20,
  paddingControlButtonIcon: 20,
  paddingControlDiv: 4,
  paddingMenu: 8,
  paddingTag: 8,
  paddingTab: 0,
  paddingArrow: 12,
  paddingTableHorizontal: 16,
  paddingTableVertical: 16,
  paddingSliceTop: 40,
  paddingSliceBottom: 60,
  marginControl: 12,
  marginFormLabelHorizontal: 16,
  marginFormLabelVertical: 4,
  marginFormTip: 4,
  marginFormFieldHorizontal: 16,
  marginFormFieldVertical: 24,
  marginFormFieldSet: 32,
  marginIcon: 12,
  marginChoice: 8,
  marginMenu: 2,
  marginTooltip: 8,
  marginTag: 8,
  marginTab: 32,
  marginBullet: 12,
  marginAttribute: 4,
  marginPopup: 8,
  sizeIconUI: 16,
  sizeIconHeader: 20,
  sizeIconWysiwyg: 14,
  sizeIllustrationS: 48,
  sizeIllustrationXM: 72,
  sizeIllustrationM: 96,
  sizeIllustrationL: 144,
  sizeIllustrationXXL: 228,
  sizeAvatarXS: 24,
  sizeAvatarS: 32,
  sizeAvatarM: 48,
  sizeAvatarL: 96,
  sizeAvatarXL: 128,
  widthTouch: "(width < 768px)",
  widthDesktopS: "(width >= 768px)",
  widthFromDesktopS: "(width >= 768px)",
  widthToTouch: "(width < 768px)",
  colorStateHover: {
    normal: "rgba(0, 0, 0, 0.04)"
  },
  colorStateActive: {
    normal: "rgba(0, 0, 0, 0.08)"
  },
  colorOverlay: {
    normal: "rgba(0, 0, 0, 0.48)"
  },
  colorText: {
    normal: "#333333"
  },
  colorTextSecondary: {
    normal: "#999999"
  },
  colorTextContrast: {
    normal: "#ffffff"
  },
  colorIcon: {
    normal: "#333333"
  },
  colorIconContrast: {
    normal: "#ffffff"
  },
  colorLink: {
    normal: "#005bd1"
  },
  colorLinkVisited: {
    normal: "#528fdf"
  },
  colorLinkContrast: {
    normal: "#ffffff"
  },
  colorTrueBlack: {
    normal: "#000000"
  },
  colorTrueWhite: {
    normal: "#ffffff"
  },
  colorState: {
    normal: "#000000"
  },
  colorAlert: {
    normal: "#c1341b"
  },
  colorIconSecondary: {
    normal: "#c7c7c7",
    hover: "#BFBFBF",
    active: "#B7B7B7"
  },
  colorBg: {
    normal: "#ffffff",
    hover: "#F5F5F5",
    active: "#EBEBEB"
  },
  colorBgPopup: {
    normal: "#ffffff",
    hover: "#F5F5F5",
    active: "#EBEBEB"
  },
  colorBgSecondary: {
    normal: "#f0f0f0",
    hover: "#E6E6E6",
    active: "#DDDDDD"
  },
  colorBgContrast: {
    normal: "#333333",
    hover: "#313131",
    active: "#2F2F2F"
  },
  colorBgThumbnail: {
    normal: "#00103d",
    hover: "#000F3B",
    active: "#000F38"
  },
  colorSuccess: {
    normal: "#28c75d",
    hover: "#26BF59",
    active: "#25B756"
  },
  colorError: {
    normal: "#ff1100",
    hover: "#F51000",
    active: "#EB1000"
  },
  colorWarning: {
    normal: "#fffce0",
    hover: "#F5F2D7",
    active: "#EBE8CE"
  },
  colorBgWarning: {
    normal: "#fffce0",
    hover: "#F5F2D7",
    active: "#EBE8CE"
  },
  colorRating: {
    normal: "#ffd400",
    hover: "#F5CC00",
    active: "#EBC300"
  },
  colorNotify: {
    normal: "#ff9e00",
    hover: "#F59800",
    active: "#EB9100"
  },
  colorSocialVk: {
    normal: "#4680C2",
    hover: "#437BBA",
    active: "#4076B2"
  },
  colorSocialOk: {
    normal: "#ee8208",
    hover: "#E47D08",
    active: "#DB7807"
  },
  colorSocialMir: {
    normal: "#117eda",
    hover: "#1079D1",
    active: "#1074C9"
  },
  colorSocialFb: {
    normal: "#0561af",
    hover: "#055DA8",
    active: "#0559A1"
  },
  colorSocialTwitter: {
    normal: "#00bff3",
    hover: "#00B7E9",
    active: "#00B0E0"
  },
  colorSocialDribbble: {
    normal: "#ea4c89",
    hover: "#E14984",
    active: "#D7467E"
  },
  colorSocialBehance: {
    normal: "#0057ff",
    hover: "#0054F5",
    active: "#0050EB"
  },
  colorPaletteRed1: {
    normal: "#fc2c38",
    hover: "#F22A36",
    active: "#E82834"
  },
  colorPaletteRed2: {
    normal: "#eb1981",
    hover: "#E2187C",
    active: "#D81777"
  },
  colorPaletteRed3: {
    normal: "#ff71bb",
    hover: "#F56CB4",
    active: "#EB68AC"
  },
  colorPaletteOrange1: {
    normal: "#ff8b2e",
    hover: "#F5852C",
    active: "#EB802A"
  },
  colorPaletteYellow1: {
    normal: "#ffc311",
    hover: "#F5BB10",
    active: "#EBB310"
  },
  colorPaletteGreen1: {
    normal: "#aee113",
    hover: "#A7D812",
    active: "#A0CF11"
  },
  colorPaletteGreen2: {
    normal: "#59c354",
    hover: "#55BB51",
    active: "#52B34D"
  },
  colorPaletteGreen3: {
    normal: "#37eb94",
    hover: "#35E28E",
    active: "#33D888"
  },
  colorPaletteGreen4: {
    normal: "#00b1b3",
    hover: "#00AAAC",
    active: "#00A3A5"
  },
  colorPaletteBlue1: {
    normal: "#2951ff",
    hover: "#274EF5",
    active: "#264BEB"
  },
  colorPaletteBlue2: {
    normal: "#00abf2",
    hover: "#00A4E8",
    active: "#009DDF"
  },
  colorPaletteBlue3: {
    normal: "#26dfdf",
    hover: "#24D6D6",
    active: "#23CDCD"
  },
  colorPaletteViolet1: {
    normal: "#6c00ff",
    hover: "#6800F5",
    active: "#6300EB"
  },
  colorPaletteViolet2: {
    normal: "#ae73ff",
    hover: "#A76EF5",
    active: "#A06AEB"
  }
};
exports.default = theme;